import { Input } from "@headlessui/react";
import SearchIcon from "@/assets/icons/search-lg.svg?react";
import "rsuite/DateRangePicker/styles/index.css";
import { useTranslation } from "react-i18next";
import { InvoiceStatusSelect } from "../invoiceStatusSelect";
import { useInvoicePaymentStatusLabels } from "@/hooks/useEnumLabels";

type litigesFilterProps = {
  setSearchField: React.Dispatch<React.SetStateAction<string>>;
  searchField: string;
  setStatusField: React.Dispatch<React.SetStateAction<string>>;
  statusField: string;
};

export const LitigesFilter = ({
  setSearchField,
  searchField,
  setStatusField,
  statusField,
}: litigesFilterProps) => {
  const { t } = useTranslation(["boInvoices", "enums"]);
  const paymentStatusLabels = useInvoicePaymentStatusLabels();
  return (
    <div className="flex flex-col justify-start gap-2 lg:flex-row">
      <InvoiceStatusSelect
        setStatusField={setStatusField}
        statusField={statusField}
        options={[
          { value: "", label: t("enums:invoicePaymentStatusFilter.all") },
          { value: "PAID", label: paymentStatusLabels.PAID },
          { value: "TOBEPAID", label: paymentStatusLabels.TOBEPAID },
        ]}
      />
      <div className="flex min-w-[300px] flex-row items-center gap-3 rounded-lg border border-solid border-gray-300 bg-white px-3 py-2">
        <SearchIcon />
        <Input
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          className="w-full text-sm font-medium focus:outline-hidden"
          placeholder={t("litigesFilter.searchPlaceholder")}
        />
      </div>
    </div>
  );
};
